var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.preferences.author.secondary_logo)?_c('img',{staticClass:"secondary-company-logo",class:{'whitelabel-enabled': _vm.hasWhiteLabel},attrs:{"src":_vm.logoSrc,"alt":_vm.preferences.author.name}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }